import { render } from "./jin-qxc.vue?vue&type=template&id=6c04d8b9&scoped=true"
import script from "./jin-qxc.vue?vue&type=script&lang=js"
export * from "./jin-qxc.vue?vue&type=script&lang=js"

import "./jin-qxc.vue?vue&type=style&index=0&id=6c04d8b9&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c04d8b9"]])

export default __exports__